import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SendMessageIcon = createIcon({
  displayName: 'SendMessageIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5036" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M10.481,18.71l10.987,-5.832c0.709,-0.376 0.709,-1.388 0,-1.765l-10.971,-5.823c-0.828,-0.44 -1.756,0.39 -1.405,1.256l2.189,5.4l-2.207,5.51c-0.346,0.867 0.581,1.692 1.407,1.254Z"></path>
        <path strokeWidth="1.5" d="M11.28,11.95l10.72,0.05"></path>
        <path strokeWidth="1.5" d="M4,15h1.6"></path>
        <path strokeWidth="1.5" d="M3,12h2.6"></path>
        <path strokeWidth="1.5" d="M2,9h3.6"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const SendMessage: FC<IconProps> = (props) => {
  return <CustomIcon as={SendMessageIcon} {...props} />
}

export default memo(SendMessage)
